// extracted by mini-css-extract-plugin
export default {"outlets":"outlets_outlets__Acwik"};